import { create } from 'zustand';

import { MovesEnum, RoundWinnerOutcomes } from '../../src/shared/constants/shared-enums';

type MockedRound = {
  round: number;
  moveA: MovesEnum;
  moveB: MovesEnum;
  winner: RoundWinnerOutcomes;
  encrMoveA?: `0x${string}`;
  encrMoveB?: `0x${string}`;
};

type MockRoundStore = {
  rounds: MockedRound[];
  addRound: (round: MockedRound) => void;
  setRounds: (rounds: MockedRound[]) => void;
  clearRounds: () => void;
};

export const useMockRoundStore = create<MockRoundStore>((set) => ({
  rounds: [],
  addRound: (round) => set((state) => ({ rounds: [...state.rounds, round] })),
  setRounds: (rounds) => set({ rounds }),
  clearRounds: () => set({ rounds: [] }),
}));
